export enum Status {
  'Pendente' = 1,
  'Processamento' = 2,
  'Finalizado' = 3,
  'Finalizado com erro' = 4,
}
